<div class="header primary p-24 h-120" fxLayout="row" fxLayoutAlign="space-between center">

  <div fxLayout="column" fxLayoutAlign="center start">
    <div fxLayout="row" fxLayoutAlign="start center">
      <mat-icon class="secondary-text s-18" *ngIf="status !== 'special-feature'">home</mat-icon>
      <mat-icon class="secondary-text s-16" *ngIf="status !== 'special-feature'">chevron_right</mat-icon>
      <span class="secondary-text">{{smallTitleHeader}}</span>
      <mat-icon class="secondary-text s-16" *ngIf="firstTitleHeader !== ''">chevron_right</mat-icon>
      <span class="secondary-text" *ngIf="firstTitleHeader !== ''">{{firstTitleHeader}}</span>

      <mat-icon class="secondary-text s-16" *ngIf="secondaryTitleHeader !== ''">chevron_right</mat-icon>
      <span class="secondary-text" *ngIf="secondaryTitleHeader !== ''">{{secondaryTitleHeader}}</span>
    </div>
    <div class="h2 mt-16">{{titleHeader}}</div>
  </div>

</div>
